const Sentry = require('@sentry/vue');

/**
 * Initialize @sentry/vue with provided Vue context and router.
 * Will also attach Sentry to `window` so it's available for use globally.
 * @param {Object} Vue
 * @param {Object} router
 * @returns {Object} Initalized Sentry client.
 */
module.exports = (Vue, router) => {
  if (!process.env.SENTRY_DSN) { return; }

  try {
    Sentry.init({
      Vue,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
      ],
      replaysSessionSampleRate: 0, // Don't capture replays in general.
      replaysOnErrorSampleRate: 1.0, // But capture all replays with an error.
      dsn: process.env.SENTRY_DSN,
      environment: process.env.NODE_ENV,
      release: process.env.COMMIT_HASH,
      tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE,
      beforeSend(event, hint) {
        const err = hint?.originalException;

        if (err?.type === 'FetchError') {
          // Don't capture generic fetch errors, since there's little-to-nothing we can do about them.
          return null;
        }

        return event;
      },
    });

    window.Sentry = Sentry;
  } catch (err) { /* noop */ }
};
